<template>
  <v-app light>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Login form</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    large
                    :href="source"
                    target="_blank"
                    slot="activator"
                  >
                    <v-icon large>code</v-icon>
                  </v-btn>
                  <span>Source</span>
                </v-tooltip>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    prepend-icon="lock"
                    name="password"
                    label="Password"
                    id="password"
                    type="password"
                    v-model="passwordRequest.password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="login">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    passwordRequest: {
      password: ""
    }
  }),
  methods: {
    login: function() {
      this.$http
        .post(
          "https://localhost:44389/api/auth/gettoken",
          JSON.stringify(this.passwordRequest),
          {
            headers: { "Content-Type": "application/json" }
          }
        )
        .then(response => {
          // set token cookie
          this.$cookie.set("token", response.data.token);

          // if successful then redirect to dashboard
          this.$router.push("/admin");
        })
        .catch(e => {});
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/Login.vue